import React, { useState, useEffect } from 'react';
import { examAPI, studentsAPI } from '../../services/api';
import DataTable from '../../components/common/DataTable';
import StatusBadge from '../../components/common/StatusBadge';
import Modal from '../../components/common/Modal';
import toast from 'react-hot-toast';
import { formatDate } from '../../utils/helpers';
import GenerateIdCards from './GenerateIdCards';
import CertificateConfig from './CertificateConfig';

const IdCardConfig = () => {
  const [tab, setTab] = useState('GenerateIdCards');
  const [exams, setExams] = useState([]);
  const [results, setResults] = useState([]);
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({ name: '', exam_type: 'unit_test', class_obj: '', start_date: '', end_date: '', status: 'scheduled' });

  // const [selectedStudents, setSelectedStudents] = useState<number[]>([]);
  // const [selectedOrientation, setSelectedOrientation] = useState < "vertical" | "horizontal" > ("vertical");
  // const [selectedSize, setSelectedSize] = useState < string > ("vertical-54x86");
  // const [paperSize, setPaperSize] = useState < string > ("A4");

  const [selectedOrientation, setSelectedOrientation] = useState("vertical");
  const [selectedSize, setSelectedSize] = useState("vertical-54x86");
  const [paperSize, setPaperSize] = useState("A4");


  useEffect(() => {
    studentsAPI.classes().then(r => setClasses(r.data.results || r.data)).catch(() => { });
    loadExams();
    loadResults();
  }, []);

  const loadExams = () => {
    setLoading(true);
    examAPI.exams().then(r => setExams(r.data.results || r.data)).catch(() => { }).finally(() => setLoading(false));
  };

  const loadResults = () => {
    examAPI.results({ page_size: 20 }).then(r => setResults(r.data.results || r.data)).catch(() => { });
  };

  const handleSaveExam = async (e) => {
    e.preventDefault();
    try {
      await examAPI.createExam(form);
      toast.success('Exam scheduled!');
      setShowModal(false);
      loadExams();
    } catch { toast.error('Failed to schedule exam'); }
  };

  const examColumns = [
    { key: 'name', label: 'Exam Name', render: v => <strong>{v}</strong> },
    { key: 'exam_type', label: 'Type', render: v => <span className="badge bg-info text-dark">{v?.replace('_', ' ')}</span> },
    { key: 'class_name', label: 'Class' },
    { key: 'start_date', label: 'Start Date', render: v => formatDate(v) },
    { key: 'end_date', label: 'End Date', render: v => formatDate(v) },
    { key: 'status', label: 'Status', render: v => <StatusBadge status={v} /> },
  ];

  const resultColumns = [
    { key: 'student_name', label: 'Student', render: v => <strong>{v}</strong> },
    { key: 'subject_name', label: 'Subject' },
    { key: 'marks_obtained', label: 'Marks', render: v => <strong>{v}</strong> },
    { key: 'max_marks', label: 'Max' },
    { key: 'percentage', label: '%', render: v => <span style={{ color: v >= 60 ? '#10b981' : v >= 35 ? '#f59e0b' : '#ef4444', fontWeight: 700 }}>{Number(v).toFixed(1)}%</span> },
    { key: 'grade', label: 'Grade', render: v => v ? <span className="badge bg-primary">{v}</span> : '—' },
    { key: 'is_pass', label: 'Result', render: v => <span className={`badge ${v ? 'bg-success' : 'bg-danger'}`}>{v ? 'Pass' : 'Fail'}</span> },
  ];

  return (
    <div>
      <div className="page-header mb-0">
        {/* <div><h2>Id Cards Configutation</h2></div> */}
        {tab === 'exams' && <button className="btn btn-primary" onClick={() => setShowModal(true)}>📅 Schedule Exam</button>}
      </div>

      <div className="d-flex gap-2 mb-4 flex-wrap">
        {[['GenerateIdCards', '📅 Generate id Cards'],['certificates', '🕒 Certificate Config'],].map(([k, l]) => (
          <button key={k} className={`btn ${tab === k ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab(k)}>{l}</button>
        ))}
         {/* ['DownloadIdCards', '🕒 Download Student / Staff Details'], ['UploadStudentPhotos', '📊 Upload Student Photos'] */}
      </div>

      {tab === 'GenerateIdCards' && (
        <GenerateIdCards />
        // <div className="card">
        //   <div className="card-header"><span>📅 GenerateIdCards ({exams.length})</span></div>
        //   <DataTable columns={examColumns} data={exams} loading={loading} />
        // </div>
      )}

      {tab === 'certificates' && (     
        <CertificateConfig/>
        // <div className="card"><div className="card-body">
        //   <div className="alert alert-info">📋 DownloadIdCards</div>
        //   <div className="row g-2 mb-3">
        //     <div className="col-md-4">
        //       <select className="form-select">
        //         <option>Select Exam</option>
        //         {exams.map(e => <option key={e.id} value={e.id}>{e.name}</option>)}
        //       </select>
        //     </div>
        //   </div>
        //   <div className="empty-state"><div className="empty-icon">🕒</div><h5>No Schedules</h5><p>Select an exam to view subject-wise schedule.</p></div>
        // </div></div>
      )}

     


      {/* <Modal show={showModal} onClose={() => setShowModal(false)} title="Schedule Examination">
        <form onSubmit={handleSaveExam}>
          <div className="mb-3"><label className="form-label">Exam Name *</label><input className="form-control" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="mb-3"><label className="form-label">Exam Type *</label>
            <select className="form-select" value={form.exam_type} onChange={e => setForm({ ...form, exam_type: e.target.value })}>
              <option value="unit_test">Unit Test</option><option value="mid_term">Mid Term</option>
              <option value="final">Final Exam</option><option value="practical">Practical</option>
            </select>
          </div>
          <div className="mb-3"><label className="form-label">Class *</label>
            <select className="form-select" value={form.class_obj} onChange={e => setForm({ ...form, class_obj: e.target.value })} required>
              <option value="">Select Class</option>
              {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <div className="row">
            <div className="col-6 mb-3"><label className="form-label">Start Date *</label><input type="date" className="form-control" value={form.start_date} onChange={e => setForm({ ...form, start_date: e.target.value })} required /></div>
            <div className="col-6 mb-3"><label className="form-label">End Date *</label><input type="date" className="form-control" value={form.end_date} onChange={e => setForm({ ...form, end_date: e.target.value })} required /></div>
          </div>
          <div className="d-flex gap-2 justify-content-end">
            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowModal(false)}>Cancel</button>
            <button type="submit" className="btn btn-primary">📅 Schedule</button>
          </div>
        </form>
      </Modal> */}
    </div>
  );
};
export default IdCardConfig;
